/**
 * Created by mac on 2019-03-22
 */

const Bundle = function (name, data) {
    this.name = name;

    this.parse(data);
};

Bundle.prototype.parse = function (data) {
    this.virtual = data.virtual;
    this.injectTo = data.injectTo;
    if (data.injectTo) {
        this.injectToSet = cleverapps.createSet(data.injectTo);
    }
    this.meta = data.meta || {};
    this.lazy = data.lazy || false;
    this.originalMeta = this.meta;

    this.frames = data.frames || {};
    this.regions = {};
    this.jsons = data.jsons || {};
    this.urls = data.urls || {};
    this.plugins = {};
    this.fromSourceResources = [];

    if (data.important) {
        this.important = data.important;
    }

    if (data.unused) {
        this.unused = cleverapps.createSet(data.unused);
    }

    if (data.plugins) {
        this.plugins[this.name] = new VirtualUrl(this.name, "plugins", { type: "plugin", name: this.name, srcs: data.plugins });
    }

    for (const frameId in this.frames) {
        const frame = this.frames[frameId] = new SpriteFrame(this.name, frameId, this.frames[frameId]);
        if (frame.fromSource) {
            this.fromSourceResources.push(frame);
        }
    }

    for (const jsonId in this.jsons) {
        const json = this.jsons[jsonId] = new VirtualJson(this.name, jsonId, this.jsons[jsonId]);
        if (json.fromSource) {
            this.fromSourceResources.push(json);
        }
    }

    for (const urlId in this.urls) {
        this.urls[urlId] = new VirtualUrl(this.name, urlId, this.urls[urlId]);
    }

    for (const key in data.soundFrames) {
        this.urls.mp3.soundFrames = data.soundFrames;
        this.urls[key] = new SoundFrame(this.name, key, data.soundFrames[key]);
    }
};

Bundle.prototype.save = function () {
    const result = {
        virtual: this.virtual,
        injectTo: this.injectTo,
        meta: this.meta,

        urls: this.urls,
        important: this.important
    };

    const frames = {};
    for (const frameId in this.frames) {
        frames[frameId] = this.frames[frameId].save();
    }
    result.frames = frames;

    const jsons = {};
    for (const jsonId in this.jsons) {
        jsons[jsonId] = this.jsons[jsonId].save();
    }
    result.jsons = jsons;

    const urls = {};
    const soundFrames = {};
    for (const urlId in this.urls) {
        const url = this.urls[urlId];
        if (url instanceof SoundFrame) {
            soundFrames[urlId] = url.save();
        } else {
            urls[urlId] = url.save();
        }
    }
    result.urls = urls;

    if (this.plugins[this.name]) {
        result.plugins = this.plugins[this.name].save().srcs;
    }

    if (!cleverapps.isEmpty(soundFrames)) {
        result.soundFrames = soundFrames;
    }

    return JSON.parse(JSON.stringify(result));
};

Bundle.prototype.onLoad = function (callback) {
    callback = callback || function () {};
    let key;

    const packedJson = this.urls.json ? cc.loader.getRes(this.urls.json) : undefined;

    for (key in this.jsons) {
        const json = this.jsons[key];
        let jsonData;
        if (json.inline) {
            jsonData = json.data;
        } else if (json.fromSource) {
            jsonData = cc.loader.getRes(json.url);
        } else if (packedJson) {
            jsonData = packedJson[json.name];
        }

        if (key === "debug_meta_json") {
            this.meta = { ...this.originalMeta, ...jsonData };
        }

        if (cleverapps.config.debugMode && cleverapps.git) {
            jsonData = cleverapps.git.urls[json.originalPath()] || jsonData;
        }

        json.setJsonData(jsonData);
    }

    let atlas, frame;

    if (this.jsons.atlas) {
        const minifiedAtlas = this.jsons.atlas.getJson();
        this.jsons.atlas.onUnload();

        try {
            atlas = BundleUtils.parseAtlas(minifiedAtlas);
        } catch (e) {
            console.error(`cant parse parseMinifiedAtlas - ${this.name}`, minifiedAtlas);
            throw e;
        }
    }

    for (key in this.frames) {
        frame = this.frames[key];

        if (frame.fromSource) {
            const texture = cc.textureCache.getTextureForKey(frame.url);
            const size = texture.getContentSize();
            frame.setFrameData({
                texture,
                rect: {
                    x: 0, y: 0, width: size.width, height: size.height
                },
                size,
                offset: cc.p(0, 0),
                rotated: false
            });
            continue;
        }

        if (atlas.frames[frame.name] === undefined) {
            console.error(frame.name);
            continue;
        }

        const frameData = atlas.frames[frame.name];
        frameData.spriteFrame = true;
        frame.setFrameData(frameData);
    }

    if (atlas) {
        this.atlas = {};

        if (engine === "cocos2d") {
            const page = BundleUtils.createPage(atlas, cc.textureCache.getTextureForKey(this.urls.png));
            for (const name in atlas.frames) {
                frame = atlas.frames[name];
                if (!frame.spriteFrame) {
                    this.regions[name] = BundleUtils.createRegion(name, frame, page);
                }
            }

            this.atlas.dispose = function () {
                if (page) {
                    page.texture.dispose();
                }
            };

            this.atlas.findRegion = function (name) {
                return this.regions[name];
            }.bind(this);
        } else {
            this.atlas.text = BundleUtils.getAtlasText(atlas);
            this.atlas.bundleName = this.name;
        }

        atlas = undefined;
    }

    if (engine === "cocos2d") {
        this.fromSourceResources.forEach((resource) => {
            if (resource.regionSource) {
                this.regions[resource.key] = BundleUtils.createSourceRegion(resource.key, cc.textureCache.getTextureForKey(resource.url));
            }
        });

        if (!this.atlas && Object.keys(this.regions).length) {
            this.atlas = {
                dispose: function () {},
                findRegion: function (name) {
                    return this.regions[name];
                }.bind(this)
            };
        }
    }

    cc.loader.release(this.urls.json);

    for (key in this.urls) {
        this.tagTexture(this.urls[key]);
    }

    this.loaded = true;

    callback();
};

Bundle.prototype.tagTexture = function (url) {
    const texture = cc.textureCache.getTextureForKey(url);
    if (texture) {
        texture.bundleName = this.name;
    }
};

Bundle.prototype.onUnload = function () {
    this.loaded = false;

    delete this.atlas;

    for (const key in this.frames) {
        this.frames[key].onUnload();
    }

    for (const jsonId in this.jsons) {
        const virtualJson = this.jsons[jsonId];
        virtualJson.onUnload();
    }

    this.regions = {};
    this.meta = this.originalMeta;
};

Bundle.prototype.listSoundUrls = function (includeLazy) {
    if (cc.sys.isWebViewAudio || this.virtual) {
        return [];
    }

    if (cleverapps.config.debugMode && cleverapps.dataLoader.load(DataLoader.TYPES.TEST_SOUNDS) === "important_only") {
        return [];
    }

    return Object.values(this.urls).filter((virtualUrl) => {
        if (virtualUrl instanceof SoundFrame || !virtualUrl.isSound()) {
            return false;
        }

        if (!virtualUrl.getUrl()) {
            return false;
        }

        if (virtualUrl.isImportant()) {
            return false;
        }

        if (!includeLazy && virtualUrl.isLazy()) {
            return false;
        }

        return true;
    });
};

Bundle.prototype.listUrls = function () {
    if (this.virtual) {
        return [];
    }

    const urls = [];

    Object.values(this.urls).forEach((virtualUrl) => {
        if (virtualUrl instanceof SoundFrame) {
            return;
        }

        if (virtualUrl.isSound()) {
            if (cc.sys.isWebViewAudio) {
                return;
            }

            if (!virtualUrl.isImportant()) {
                return;
            }

            if (virtualUrl.isLazy()) {
                return;
            }
        } else if (virtualUrl.isLazy()) {
            return;
        }

        urls.push(virtualUrl);
    });

    this.fromSourceResources.forEach((virtualUrl) => {
        if (virtualUrl.isLazy()) {
            return;
        }
        
        urls.push(virtualUrl);
    });

    urls.push(...Object.values(this.plugins));

    return urls.filter((virtualUrl) => virtualUrl.getUrl());
};

Bundle.prototype.isInjectTo = function (name) {
    if (Array.isArray(name)) {
        return name.some(this.isInjectTo.bind(this));
    }
    return this.name === name || this.injectTo && this.injectTo.includes(name);
};

Bundle.prototype.getBundleName = function () {
    return this.name;
};

Bundle.prototype.isLoaded = function () {
    return cleverapps.bundleLoader.isLoaded(this.name);
};
